module.exports = __webpack_public_path__ + "static/media/title.bb8465d3.png";